import { LogLevel, PublicClientApplication } from '@azure/msal-browser';

const clientId = process.env.REACT_APP_MSAL_CLIENT_ID || '';

export const msalConfig = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_MSAL_TENANT_ID || ''}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    // localStorage persists the refresh token across tabs/reloads, so
    // acquireTokenSilent renews via the refresh token (a direct /token call)
    // instead of the hidden-iframe SSO flow — which is what trips
    // block_iframe_reload (the iframe loads redirectUri = this app, and we
    // can't register a dedicated blank redirect page in Entra).
    cacheLocation: 'localStorage',
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level === LogLevel.Error) console.error('[MSAL]', message);
      },
    },
  },
};

export const loginRequest = {
  scopes: process.env.REACT_APP_MSAL_SCOPES
    ? process.env.REACT_APP_MSAL_SCOPES.split(' ')
    : [`api://${clientId}/access`],
};

export const msalInstance = new PublicClientApplication(msalConfig);
